module.exports = "<p>\n  project-received-lp-form works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/planning/project-received-land-pro-details/project-received-lp-form/project-received-lp-form.component.html
// module id = ./src/app/planning/project-received-land-pro-details/project-received-lp-form/project-received-lp-form.component.html
// module chunks = main